import { gql } from "@apollo/client";

export const GET_AUTORIZACION_DETALLE = gql`
query GetPrecioControlById($idPrecioControl: Int!) {
  precioControlById(idPrecioControl: $idPrecioControl) {
    idAutorizacionControl
    region
    delegacion
    evento
    fecha
    solicitante
    contrato
    modulo
    codigo
    financiador
    periodo
    precioControl
    precioACambiar
    idMinuta
    observacion
    observacionGG
    idUsuarioSolicitante
    archivoCotizacion {
      titulo
      contentType
      extension
      fechaAlta
      archivo
    }
  }
}`;